<template>
	<OneOnOneListCardLayout :class="classes">
		<template v-slot:name>
			<label class="one-on-one-list-header-card__column-label">
				{{ $t( "common.OneOnOneListHeaderCard_nameColumnHeader" ) }}
			</label>
		</template>
		<template v-slot:status>
			<label class="one-on-one-list-header-card__column-label">
				{{ $t( "common.OneOnOneListHeaderCard_statusColumnHeader" ) }}
			</label>
		</template>
		<template v-slot:role>
			<label class="one-on-one-list-header-card__column-label">
				{{ $t( "common.OneOnOneListHeaderCard_roleColumnHeader" ) }}
			</label>
		</template>
	</OneOnOneListCardLayout>
</template>

<script>
import OneOnOneListCardLayout from "./OneOnOneListCardLayout";

export default {
	name: "OneOnOneListHeaderCard",
	components: {
		OneOnOneListCardLayout,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
	},
	computed: {
		classes() {
			return {
				"one-on-one-list-header-card": true,
				[ this.className ]: !!this.className,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
.one-on-one-list-header-card {
	height: 1.875rem;
}

.one-on-one-list-header-card__column-label {
	@include font-and-line-for(0);
	font-weight: 600;
	color: $one-on-one-list-header-card-column-label-color;
}
</style>
